<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Monitor">
    <template v-slot:body>
      <RealTimeData v-if="Object.keys(data.real_time_data || {}).length > 0" :config="data.real_time_data"></RealTimeData>
      <Network v-if="Object.keys(data.network || {}).length > 0" :config="data.network"></Network>
      <ServerParameter :config="data.server_parameter"></ServerParameter>
    </template>
  </Body>
</template>

<script>
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import ServerParameter from './Section/ServerParameter.vue'
import RealTimeData from './Section/RealTimeData.vue'
import Network from './Section/Network.vue'

export default {
  mixins: [Event],
  components: {
    Header,
    SideBar,
    Body,
    ServerParameter,
    RealTimeData,
    Network
  },
  data() {
    return {
      interval: null
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.refreshData(1)
  },
  unmounted() {
    this.clearRefreshData()
  },
  methods: {
    refreshData(initialized) {
      this.$util.forceGet(
        'monitor/index',
        {
          init: initialized ? 1 : 0
        },
        initialized ? this.$el : null,
        {
          done: (response) => {
            this.setUpData(response)
          }
        }
      )
    },
    loopRefreshData() {
      this.interval = setInterval(() => {
        this.refreshData()
      }, 1000)
    },
    clearRefreshData() {
      clearInterval(this.interval)
      this.interval = null
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        if (Object.keys(rawData.data).length > 2) {
          this.store.commit('', rawData.data)
          if (_.isObjectLike(rawData.data.real_time_data)) {
            this.loopRefreshData()
          }
        } else {
          this.store.commit('real_time_data', rawData.data.real_time_data || {})
          this.store.commit('network', rawData.data.network || {})
        }
      }
    }
  }
}
</script>
